<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="block block-form">
      <div class="block-tilte">佣金提现审核</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="支付宝账号">
          <el-input v-model="searchForm.alipay" placeholder="请输入支付宝账号" />
        </el-form-item>
        <el-form-item label="提现金额">
          <el-input v-model="searchForm.withdrawMix" placeholder="最小提现金额" style="width: 150px;" />
          <span style="padding: 0 5px;">至</span>
          <el-input v-model="searchForm.withdrawMax" placeholder="最大提现金额" style="width: 150px;" />
        </el-form-item>
        <el-form-item label="提现日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.start_time_bak" style="width: 150px;">
          </date-picker>
          <span style="padding: 0 5px;">至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.end_time_bak" style="width: 150px;"></date-picker>
        </el-form-item>
        <el-form-item label="提现状态">
          <el-select v-model="searchForm.state" placeholder="请选择提现状态">
            <el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="交易单号">
          <el-input v-model="searchForm.withdrawNo" placeholder="请输入交易单号" />
        </el-form-item>
        <el-form-item label="提现方式">
          <el-select v-model="searchForm.withdrawType" placeholder="请选择提现方式">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button style="margin-left:12px" type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>



    <!-- <div class="tilte-text"> 佣金提现审核</div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <Input v-model="searchForm.alipay" placeholder="支付宝账号" style="width: 150px;" />
      </template>
<template>
        <span style="padding-left: 20px;">提现金额</span>
        <Input v-model="searchForm.withdrawMix" placeholder="提现金额" style="width: 150px;" />
        <span style="padding: 0 5px;">至</span>
        <Input v-model="searchForm.withdrawMax" placeholder="提现金额" style="width: 150px;" />
      </template>
<br>
<template>
        <span>提现时间</span>
        <DatePicker type="date" placeholder="选择日期" v-model="searchForm.start_time_bak" style="width: 150px;">
        </DatePicker>
        <span style="padding: 0 5px;">至</span>
        <DatePicker type="date" placeholder="选择日期" v-model="searchForm.end_time_bak"></DatePicker>
      </template>
<template>
        <span style="padding-left: 20px;">提现状态</span>
        <Select v-model="searchForm.state" style="width:150px" placeholder="全部">
          <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
<template>
        <span style="padding-left: 20px;">交易单号</span>
        <Input v-model="searchForm.withdrawNo" placeholder="请输入单号" style="width: 150px;" />
      </template>
<template>
        <span style="padding-left: 20px;">提现方式</span>
        <Select v-model="searchForm.withdrawType" style="width:150px" placeholder="全部">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
<template>
        <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="onFormSearch">查询</Button>
      </template>
</div> -->
    <div class="block block-top">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="withdraw">
          <span class="color-ff9" v-if="row.withdraw >= 0">￥{{ row.withdraw }}</span>
          <span class="color-ff9" v-else>-</span>
        </template>
        <template slot-scope="{ row }" slot="state">
          <span class="color-ff9" v-if="row.state == 0">待审核</span>
          <span class="color-666" v-if="row.state == 10">审核成功(待打款)</span>
          <span class="color-666" v-if="row.state == 15">打款中</span>
          <span class="color-ff4" v-if="row.state == 20">审核驳回</span>
          <span class="color-666" v-if="row.state == 30">打款成功</span>
          <span class="color-ff4" v-if="row.state == 40">打款失败</span>
        </template>
        <template slot-scope="{ row }" slot="withdrawType">
          <span class="color-ff9" v-if="row.withdrawType == 0">支付宝</span>
          <span class="color-666" v-if="row.withdrawType == 1">银行卡</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <!--          <span class="color-41a" style="cursor: pointer;" v-if="row.state == 0" @click="audit(row.id)">仅审核不打款</span>-->
          <span class="color-ff4" style="cursor: pointer;" v-if="row.state == 0 || row.state == 10"
            @click="remit(row.id)">打款</span>
          <span class="color-ff4" style="cursor: pointer;" v-if="row.state == 0" @click="reject(row.id)">驳回</span>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
      <Audit ref="Audit" @refreshList="getList(true)"></Audit>
      <Reject ref="Reject" @refreshList="getList(true)"></Reject>
    </div>
  </div>
</template>
<script>
import { getPlatformUuid } from '@/utils/auth'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'
import { getDate } from '@/utils/date'
import Audit from '@/views/pc/official/commission/modal/Audit'
import Reject from '@/views/pc/official/commission/modal/Reject'
import commission from '@/javaApi/commission'
const commissionModel = new commission()
export default {
  name: 'Mingxi',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker,
    Audit,
    Reject
  },
  data: function () {
    return {
      columns: [
        {
          title: '序号',
          key: 'sequence',
          width: 80
        },
        {
          title: '微信名',
          key: 'nickName',
          width: 150,
          ellipsis: true,
          render: (h, params) => {
            let nickName = params.row.nickName
            let headPic = params.row.headPic
            let renderData = []
            if (headPic) {
              renderData.push(
                h('img', {
                  attrs: {
                    src: headPic,
                    width: 20
                  },
                })
              )
            }
            renderData.push(
              h('span', {}, nickName)
            )
            return renderData
          }
        },
        // {
        //   title: '手机号',
        //   key: 'phone',
        //   width: 150
        // },
        {
          title: '交易单号',
          key: 'withdrawNo',
          width: 150
        },
        {
          title: '真实姓名',
          key: 'name',
          width: 150
        },
        {
          title: '收款账号',
          key: 'alipay',
          width: 150
        },
        {
          title: '提现金额',
          key: 'withdraw',
          slot: 'withdraw',
          width: 150
        },
        {
          title: '提现方式',
          slot: 'withdrawType',
          key: 'withdrawType',
          width: 150
        },
        {
          title: '提现时间',
          key: 'createTime',
          width: 150
        },
        {
          title: '提现状态',
          key: 'state',
          slot: 'state',
          width: 120,
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 200,
        },
        {
          title: '备注',
          align: 'center',
          key: 'remark',
          width: 200,
        }
      ],
      listLoading: false,
      status_list: [
        { "label": "全部", "value": "" },
        { "label": "待审核", "value": "0" },
        { "label": "审核成功", "value": "10" },
        { "label": "审核驳回", "value": "20" },
        { "label": "打款成功", "value": "30" },
        { "label": "打款失败", "value": "40" }
      ],
      list: [],
      total: 0,
      platformUuid: getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        alipay: undefined,
        phone: undefined,
        withdrawMix: undefined,
        withdrawMax: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        state: undefined,
        bankCardNum: undefined,
        withdrawNo: undefined,
        withdrawType: undefined
      },
      // 提现方式
      typeList: [
        { "label": "全部", "value": "" },
        { "label": "支付宝", "value": "0" },
        { "label": "银行卡", "value": "1" },
        // {"label":"银行卡","value":"3"},
      ]
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      let condition = (this.platformUuid == '' || this.pstatisticslatformUuid == 0);
      if (!condition) {
        searchForm.platformUuid = this.platformUuid
      }
      searchForm.createStartTime = getDate(searchForm.start_time_bak)
      searchForm.createEndTime = getDate(searchForm.end_time_bak)
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      searchForm = this.formateInit(searchForm)
      console.log(searchForm)
      if (searchForm.createStartTime) {
        searchForm.createStartTime = searchForm.createStartTime + ' 00:00:00'
      }
      if (searchForm.createEndTime) {
        searchForm.createEndTime = searchForm.createEndTime + ' 23:59:59'
      }
      commissionModel.getCommList(searchForm).then((response) => {
        var res = response.data
        this.listLoading = false
        if (res.code != 200) {
          this.$Message.error(res.message)
          return
        }
        this.list = this.formateData(res.data.list)
        this.total = res.data.total
      })
    },
    formateData(data) {
      if (!data) {
        return []
      }
      if (!data.length) {
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for (i = 0; i < data.length; i++) {
        data[i].sequence = (i + 1) + (pageNo - 1) * pageSize
        // 处理当是银行卡提现时显示收款账户银行卡数据
        if (data[i].alipay == '') {
          data[i].alipay = data[i].bankCardNum
        }
      }
      return data
    },
    onFormSearch() {
      this.getList(true)
    },
    onFormReset() {
      this.searchForm.alipay = undefined
      this.searchForm.phone = undefined
      this.searchForm.withdrawMix = undefined
      this.searchForm.withdrawMax = undefined
      this.searchForm.start_time_bak = undefined
      this.searchForm.end_time_bak = undefined
      this.searchForm.createStartTime = undefined
      this.searchForm.createEndTime = undefined
      this.searchForm.state = undefined
      this.searchForm.bankCardNum = undefined
      this.searchForm.withdrawNo = undefined
      this.searchForm.withdrawType = undefined
      this.onFormSearch()
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    //仅审核不打款
    audit(id) {
      this.$refs.Audit.init(true, id, 1)
    },
    //打款
    remit(id) {
      this.$refs.Audit.init(true, id, 2)
    },
    //驳回
    reject(id) {
      this.$refs.Reject.init(true, id)
    },
    formateInit(formData) {
      let objCopy = {};
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 30px;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: "\F33D";
}

.ivu-date-picker-rel {
  margin: 11px 0;
}

.ivu-table {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #FFFFFF !important;
}


.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/commission/Index.vue